var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BTag',{class:[_vm.tagClass, 'has-text-weight-bold']},[_vm._v(" "+_vm._s(_vm.$t(("common.costTypes." + (_vm.costTypes[_vm.costTypeId].name))))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }